/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from "react";
import { useState } from "react";
import { Button } from "@mui/material";
import Footer from "../../Components/Footer";
import ScrollToTop from "../../Components/scrollpageUp";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import MailIcon from "@mui/icons-material/Mail";
import RestaurantIcon from '@mui/icons-material/Restaurant';
import "./style.css";
import infoPic from '../../images/infoPic.jpg'
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
export default function Info() {
    
  const theme = createTheme({
    palette: {
      primary: {
         
              main: '#000',
              dark: '#222',
              contrastText: '#FFCD00',
      },
    },
  });
 
  return (
    <ThemeProvider theme={theme}>
    <div className="menu">
    <h1>Bienvenue chez La Mascotte <RestaurantIcon fontSize="small"/> </h1>
    <p className="infoDescreption">où chaque plat vous promet une expérience culinaire unique à savourer en famille, 
        entre amis ou en solo.<br/> Découvrez nos créations culinaires,
         préparées avec amour pour vous offrir un moment gastronomique exceptionnel.</p>
          <ScrollToTop/>
          <img src={infoPic} alt="info Pic" className="infoPic"/>
    <div>
        <div className="infoDetails">
            <div>
                <h4>  contact   </h4>
        <a href="tel:52 735 777" className="footer-link"> <PhoneAndroidIcon fontSize="small"/>52 735 777
       </a><br/>
       <a href="mailto:hellolamascotte@gmail.com" className="contact-link">
      <MailIcon fontSize="small"/> hellolamascotte@gmail.com
              </a><br/>
              <a href="#" className="contact-link">
      <LocationOnIcon fontSize="small"/> 
    Mall Of Sfax  Route de Tunis Km10, Sfax 
              </a>
                </div>           
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13098.260971926837!2d10.76314!3d34.842022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1301d15f427fb715%3A0x54b8ce150a0bc145!2sMall%20of%20Sfax!5e0!3m2!1sfr!2stn!4v1720615970991!5m2!1sfr!2stn" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" className="infoMap"></iframe>
    </div>
    </div>
            
      <Footer/>
    </div>
    </ThemeProvider>
  );
}
